import { useQuery } from '@tanstack/react-query'

import { QUERY_KEYS } from 'constants/constants'
import { query } from '../graphql'
import { employeeContextFilterInput } from '../graphql/filter-inputs'

// EMPLOYEE-Spaces des Partners, also die Mitglieder unter /settings/user. Die
// Mitgliederliste und der Zugangs-Zähler (features/pricing/usage-queries.js)
// nutzen denselben Key und dieselbe queryFn und teilen so einen Cache. Kaputte
// Spaces ohne person bleiben drin, die Liste und countSeats filtern sie selbst.
export const fetchTeamMembers = (partnerId) =>
  query({
    query: 'spacesByPartnerIdByUpdatedAt',
    variables: {
      partner_id: partnerId,
      filter: employeeContextFilterInput
    }
  })

export const teamMembersQueryOptions = ({ partnerId }) => ({
  queryKey: QUERY_KEYS.userManagementByPartner(partnerId),
  queryFn: () => fetchTeamMembers(partnerId)
})

export const useTeamMembersQuery = ({ partnerId }) =>
  useQuery(teamMembersQueryOptions({ partnerId }))
